import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "repo/get";
import InputMask from "react-input-mask";
import DeleteButton from "components/hooks/DeleteButton";
import UpdateButton from "../UpdateButton";
function FichaDetails({ ficha, onClose, onDeleteSuccess, onUpdateSuccess }) {
  const [nome, setNome] = useState(ficha.nome || "");
  const [email] = useState(ficha.email || "");
  const [cpf] = useState(ficha.cpf || "");
  const [telefone, setTelefone] = useState(ficha.telefone || "");

  const isEdited = nome !== ficha.nome || telefone !== ficha.telefone;

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <div className="flex justify-between items-center mb-4">
        <div className="flex flex-col md:flex-row   space-x-2">

          <DeleteButton data={"funcionarios/deleteById/"} userId={ficha.id} cargo=" administrador" onDeleteSuccess={onDeleteSuccess} />
          {isEdited && (
            <UpdateButton data={"funcionarios/updateSite/"} nome={nome} telefone={telefone} userId={ficha.id} cargo=" administrador" onUpdateSuccess={onUpdateSuccess} />
          )}
        </div>
      </div>

      <div className="flex items-start justify-between mt-8">
        <div className="flex-1">
          {/* Campo Nome */}
          <div className="relative w-full mb-3">
            <label
              className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              htmlFor="nome"
            >
              Nome completo
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              value={nome}
              onChange={(e) => setNome(e.target.value)} 
              required
            />
          </div>

          {/* Campo Email */}
          <div className="relative w-full mb-3">
            <label
              className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              type="email"
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              value={email} 
              required
              disabled
            />
          </div>

          {/* Campo CPF */}
          <div className="relative w-full mb-3">
            <label
              className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              htmlFor="cpf"
            >
              CPF
            </label>
            <InputMask
              mask="999.999.999-99"
              className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              value={cpf} 
              required
              disabled
            >

            </InputMask>
          </div>

          {/* Campo Telefone */}
          <div className="mb-2">
            <div className="relative w-full mb-3">
              <label
                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                htmlFor="telefone"
              >
                Telefone
              </label>
              <InputMask
                mask="(99)99999-9999"
                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                value={telefone} 
                onChange={(e) => setTelefone(e.target.value)} 
                required
              >
                {(inputProps) => <input {...inputProps} type="text" />}
              </InputMask>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const CardDataTable = () => {
  const [data, setData] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(null);
  const [filters, setFilters] = useState({
    'nome': { value: null, matchMode: 'contains' },
    'telefone': { value: null, matchMode: 'contains' },
  });
  const { data: fetchedData } = useFetchData("api/funcionarios/findAll");

  useEffect(() => {
    if (fetchedData) {
      const formattedData = fetchedData.map((item) => ({
        ...item,
        nome: item.nome,
        email: item.email,
        cpf: item.cpf,
        telefone: item.telefone,
        base: item.base.map((b) => b.nome).join(", "),
        baseIds: item.base.map((b) => b.id),
      }));
      const baseSelectedId = Number(localStorage.getItem("baseSelected"));
      const filteredData = formattedData.filter((item) =>
        item.baseIds.includes(baseSelectedId)
      );
      setData(filteredData.filter(func => func.role === "ADMIN"));
    }
  }, [fetchedData]);

  const onRowSelect = (e) => {
    setSelectedFicha(e.data);
  };

  const closeDetails = () => {
    setSelectedFicha(null);
  };

  const handleDeleteSuccess = (deletedUserId) => {
    setData((prevData) => prevData.filter((item) => item.id !== deletedUserId));
    closeDetails();
  };
  const handleUpdateSuccess = (updatedUser) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedUser.id ? { ...item, ...updatedUser } : item
      )
    );
    closeDetails();
  };
  const header = (
    <div className="table-header">
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold p-component">
            ADMINISTRADORES
          </h1>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center w-full">
        <span className="p-input-icon-left">
          <InputText
            type="search"
            onInput={(e) => setFilters({ ...filters, global: { value: e.target.value, matchMode: 'contains' } })}
            placeholder="Buscar..."
          />
        </span>
        <h4 className="p-input-icon-right text-2xl uppercase font-bold text-blueGray-700 ml-auto">
          {data.length} Administradores
        </h4>
      </div>
    </div>
  );

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
        {selectedFicha && (
          <Dialog header="Detalhes do administrador" visible={true} style={{ width: '70%' }} onHide={closeDetails}>
            <FichaDetails ficha={selectedFicha} onClose={closeDetails} onDeleteSuccess={handleDeleteSuccess} onUpdateSuccess={handleUpdateSuccess} />
          </Dialog>

        )}

        <DataTable
          value={data}
          paginator
          rows={25}
          stripedRows
          rowsPerPageOptions={[5, 10, 25, 50]}
          tableStyle={{ minWidth: "50rem" }}
          selectionMode="single"
          onRowSelect={onRowSelect}
          filters={filters}
          globalFilterFields={['nome', 'telefone']}
          emptyMessage="Nenhum resultado encontrado."
          header={header}
        >
          <Column
            field="nome"
            header="Nome do Funcionario"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />
          <Column
            field="telefone"
            header="Telefone"
            sortable
            style={{ minWidth: '12rem', fontSize: '13px' }}
          />
        </DataTable>

      </div>
    </>
  );

}

export default CardDataTable;
